var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.02 31.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f05123;}.cls-2{fill:#323338;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7710",
    "data-name": "Path 7710",
    className: "cls-1",
    d: "M23.7,18.48a10.05,10.05,0,0,0-10-10.06h0V18.48l-5-8.72a10.05,10.05,0,0,0,5,18.77h.55l.42,0h.1l.38,0,.13,0,.34-.06.17,0,.28-.06.22-.06.22-.06.28-.09L16.9,28l.32-.12.12-.05a2.75,2.75,0,0,0,.36-.15l.09,0a3.26,3.26,0,0,0,.38-.18l.07,0,.37-.2.05,0h0a10,10,0,0,0,5-8.71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7711",
    "data-name": "Path 7711",
    className: "cls-2",
    d: "M13.65,5.1A13.38,13.38,0,1,0,27,18.48,13.37,13.37,0,0,0,13.65,5.1m0,25.75A12.38,12.38,0,1,1,26,18.48h0A12.39,12.39,0,0,1,13.65,30.85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7712",
    "data-name": "Path 7712",
    className: "cls-2",
    d: "M15.83,0H11.47a.66.66,0,0,0,0,1.32H13v2.6a5.83,5.83,0,0,1,1.32,0V1.32h1.52a.66.66,0,0,0,.65-.66A.65.65,0,0,0,15.83,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7713",
    "data-name": "Path 7713",
    className: "cls-2",
    d: "M4,5.92,3.17,4.86A16.14,16.14,0,0,0,0,8l1.05.79c.28-.37.59-.73.9-1.08l1,1a6.82,6.82,0,0,1,.91-1l-1-1c.34-.31.7-.61,1.07-.89"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7714",
    "data-name": "Path 7714",
    className: "cls-2",
    d: "M18.28,10.45h0a.43.43,0,0,0,.58-.16h0l.48-.83A.42.42,0,1,0,18.61,9l-.48.83a.43.43,0,0,0,.15.59h0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7715",
    "data-name": "Path 7715",
    className: "cls-2",
    d: "M8.1,28.08h0a.45.45,0,0,0,.59-.16h0l.48-.83A.43.43,0,0,0,9,26.51a.42.42,0,0,0-.58.15L8,27.49a.43.43,0,0,0,.15.59h0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7716",
    "data-name": "Path 7716",
    className: "cls-2",
    d: "M4.2,13.52,5,14a.45.45,0,0,0,.59-.16.44.44,0,0,0-.16-.58l-.83-.48a.42.42,0,0,0-.58.15.43.43,0,0,0,.15.59"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7717",
    "data-name": "Path 7717",
    className: "cls-2",
    d: "M21.83,23.7l.83.48a.45.45,0,0,0,.59-.16.44.44,0,0,0-.16-.58L22.26,23a.42.42,0,0,0-.58.15.43.43,0,0,0,.15.59"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7718",
    "data-name": "Path 7718",
    className: "cls-2",
    d: "M18.13,27.09l.48.83a.42.42,0,1,0,.73-.43h0l-.48-.83a.42.42,0,0,0-.73.43"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7719",
    "data-name": "Path 7719",
    className: "cls-2",
    d: "M8,9.46l.48.83a.44.44,0,0,0,.58.16.45.45,0,0,0,.16-.59h0L8.69,9a.43.43,0,0,0-.59-.15A.42.42,0,0,0,8,9.46"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7720",
    "data-name": "Path 7720",
    className: "cls-2",
    d: "M4.05,24h0a.43.43,0,0,0,.58.16h0l.83-.49A.42.42,0,1,0,5,23l-.83.48a.42.42,0,0,0-.15.58h0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7721",
    "data-name": "Path 7721",
    className: "cls-2",
    d: "M23.25,12.93h0a.42.42,0,0,0-.58-.15h0l-.84.48a.42.42,0,0,0-.15.58.43.43,0,0,0,.58.16l.83-.48a.43.43,0,0,0,.16-.59h0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7722",
    "data-name": "Path 7722",
    className: "cls-2",
    d: "M13.65,29.56h0a.42.42,0,0,0,.43-.42h0v-1a.42.42,0,0,0-.43-.42h0a.42.42,0,0,0-.43.42h0v1a.42.42,0,0,0,.43.42h0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7723",
    "data-name": "Path 7723",
    className: "cls-2",
    d: "M13.65,9.2h0a.42.42,0,0,0,.43-.42h0v-1a.43.43,0,0,0-.43-.43h0a.43.43,0,0,0-.43.43h0v1a.42.42,0,0,0,.43.42h0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7724",
    "data-name": "Path 7724",
    className: "cls-2",
    d: "M4,18.05H3a.43.43,0,1,0,0,.85H4a.43.43,0,0,0,0-.85"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7725",
    "data-name": "Path 7725",
    className: "cls-2",
    d: "M22.92,18.48h0a.42.42,0,0,0,.43.42h1a.42.42,0,0,0,.42-.42h0a.42.42,0,0,0-.42-.43h-1a.43.43,0,0,0-.43.43h0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7726",
    "data-name": "Path 7726",
    className: "cls-2",
    d: "M14.35,18.07s0,0,0,0c-.3-.6-4.51-6.49-4.94-7.07a.05.05,0,0,0-.08,0,.06.06,0,0,0,0,.07h0c.29.66,3.2,7.14,3.62,7.81l0,.05a.81.81,0,0,0,1.41-.81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockOut);
export default __webpack_public_path__ + "static/media/clockOut.14852efaf75f69b6a8613fcd7c89d14e.svg";
export { ForwardRef as ReactComponent };